import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';

import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { CompaniesProvider } from '../../../providers/companies/companies.provider';

import { Empresa, EmpresaApi } from '../../../services/lbsdk';
import { AuthService } from '../../../services/auth/auth.service';
import { Constants } from '../../../constants';
import { ServiciosSharedService } from '../../../services/servicios-shared.service';
//import { Base64 } from '@ionic-native/base64';
/**
 * Generated class for the CompanyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-empresa',
  templateUrl: 'control-empresa.html',
})
export class ControlEmpresaPage {

  urlLogoClaroPreview: string = "assets/icon/logo.jpg";
  urlLogoOscuroPreview: string = "assets/icon/logo.jpg";

  company: Empresa = null;
  action: string = "";

  form: FormGroup;
  id: string;
  close: boolean = false; //ARREGLAR 
  archivo
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private providerCompanies: CompaniesProvider,
    private toastCtrl: ToastController, private empresaApi: EmpresaApi,
    private authService: AuthService//, private base64: Base64
    , private sharedMensaje: ServiciosSharedService
  ) {
    this.armarForm();

    this.company = navParams.get("data")

  }
  volver(){
    this.navCtrl.pop();
  }
  private armarForm() {
    this.form = this.formBuilder.group({
      razonSocial: new FormControl('', [Validators.required]),
      nombreFantasia: new FormControl('', [Validators.required]),
      emailRecepcion: new FormControl('', [Validators.required, Validators.email]),
      emailAdministrativo: new FormControl('', [Validators.required, Validators.email]),
      telefonoContacto: new FormControl('', [Validators.required]),
      domicilio: new FormControl('', [Validators.required]),
      nombreContacto: new FormControl('', [Validators.required]),
      telefonoInforme: new FormControl('', [Validators.required]),
      emailInforme: new FormControl('', [Validators.required, Validators.email]),
      cuit: new FormControl('', [Validators.required]),
      activo: new FormControl('', []),
      externo: new FormControl('', []),
      /*,
      logoOscuro: new FormControl('', []),
      logoClaro: new FormControl('', [])*/
    })
  }

  abrir() {
    console.log("LOGO CLARO ", this.imageLogoClaro)
    console.log("LOGO OSCURO ", this.imageLogoOscuro)
    // let win: any = window;
    // let filePath: string = 'file:///' + this.archivo;
    // let safeURL = win.Ionic.WebView.convertFileSrc(filePath);


    // this.base64.encodeFile(safeURL).then((base64File: string) => {
    //   console.log(base64File);
    // }, (err) => {
    //   console.log(err);
    // });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CompanyPage');
    if (this.company.idEmpresa == null) {
      console.log("Nuevo registro");
      this.action = "Nuevo registro";
      this.company.activo = false;
      this.company.externo = false;
    } else {
      console.log("Actualizando registro => ", this.company);
      this.action = "Actualizar registro";
      if (this.company.logoClaro == "-") {
        this.urlLogoClaroPreview = this.company.logoClaro
      }
      else {
        this.urlLogoClaroPreview = Constants.urlEmpresa + this.company.idEmpresa.toString() + '/download/logoClaro.png'
      }

      if (this.company.logoOscuro == "-") {
        this.urlLogoOscuroPreview = this.company.logoOscuro
      }
      else {
        this.urlLogoOscuroPreview = Constants.urlEmpresa + this.company.idEmpresa.toString() + '/download/logoOscuro.png'
      }



    }
  }

  guardar() {
    console.log(this.authService.userData)


    if (!this.form.valid) {

      Object.keys(this.form.controls).forEach((control: string) => {
        const typedControl: AbstractControl = this.form.controls[control];
        if (typedControl.valid == false) {
          console.log(" control ", typedControl)
          this.showToast("Debe completar el campo " + control.toString() + ".")
          return;
        }
      });
      return;
    }

    this.company.idUsuario = this.authService.userData.userId

    if (this.imageLogoClaro != "" && this.imageLogoClaro != null) {
      this.company['base64claro'] = this.imageLogoClaro
      this.company.logoClaro = "logoClaro.png" //this.imageLogoClaro
    }
    else {
      this.company['base64claro'] = "-"
      if (this.company.idEmpresa == 0) {
        this.company.logoClaro = "-"
      }
    }

    if (this.imageLogoOscuro != "" && this.imageLogoOscuro != null) {
      this.company['base64oscuro'] = this.imageLogoOscuro
      this.company.logoOscuro = "logoOscuro.png" //this.imageLogoOscuro
    }
    else {
      this.company['base64oscuro'] = "-"
      if (this.company.idEmpresa == 0) {
        this.company.logoOscuro = "-"
      }

    }




    if (this.company.idEmpresa != null) {
      this.company.fechaCreacion = new Date();
      this.empresaApi.AddUpdateEmpresa(this.company)//this.empresaApi.patchAttributes(this.company.idEmpresa, this.company)
        .subscribe(() => {
          this.showToast("Registro actualizado con exito!");
          this.navCtrl.pop();
        }, error => {
          console.log(error);
        })
    } else {
      this.company.fechaCreacion = new Date();
      this.empresaApi.AddUpdateEmpresa(this.company)//.create(this.company)
        .subscribe(() => {
          this.showToast("Registro creado con exito!");
          this.navCtrl.pop();
        }, error => {
          console.log(error);
        })
    }
  }

  showToast(msg: string) {
    let position = 'bottom';
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 2000,
      position: position
    });
    toast.present(toast);
  }


  //#region MENSAJES DE VALIDACION
  validation_messages = {
    'requiredOnly': [
      { type: 'required', message: '* Este campo es requerido.' }
    ],
    'email': [
      { type: 'required', message: '* Este campo es requerido.' },
      { type: 'email', message: '* Debe ser del formato correo.' }
    ]
  }
  //#endregion

  // file: File;

  imageLogoClaro: string = "";
  imageLogoOscuro: string = "";

  cargarImagen($event, tipo): void {
    let file2: File
    file2 = $event.target.files[0];
    console.log(file2);
    var reader = new FileReader();
    reader.addEventListener('error', () => {
      this.sharedMensaje.mostrarMensajeError("No se logró procesar la imagen, revise que el formato sea jpg o png.")
    });
    reader.readAsDataURL(file2);
    //reader.onload = function () {
    reader.onload = (e: any) => {


      let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
      if ((encoded.length % 4) > 0) {
        encoded += '='.repeat(4 - (encoded.length % 4));
      }

      if (reader.result.toString().includes("svg")) {
        this.sharedMensaje.mostrarMensajeError("No se logró procesar la imagen, revise que el formato sea jpg o png.")
        return;
      }
      if (tipo == "C") {
        this.imageLogoClaro = encoded;
        this.urlLogoClaroPreview = reader.result.toString();
      }
      else {
        this.imageLogoOscuro = encoded;
        this.urlLogoOscuroPreview = reader.result.toString();
      }
      //this.imageLogoClaro = encoded
      // this.company.logoOscuro = encoded
      console.log(encoded)
    };
    reader.onerror = (e: any) => {
      this.sharedMensaje.mostrarMensajeError("No se logró procesar la imagen, revise que el formato sea jpg o png.")
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/empresas/control-empresa/control-empresa.ts